<template>
    <v-card class="overflow-x-hidden">
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeDialog()">
            <v-icon>mdi-keyboard-backspace</v-icon>
            </v-btn>
            <v-toolbar-title>{{localChat.name}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-card
                color="#385F73"
                dark
                class="ma-auto"
                >
                    <v-card-subtitle v-if="localChat.type==='Private'" class="pa-1">Private</v-card-subtitle>
                    <v-card-subtitle v-if="localChat.type==='Group'" class="pa-1">Group</v-card-subtitle>
                </v-card>
            </v-toolbar-items>
        </v-toolbar>

        <v-card
        v-scroll.self="onScroll"
        class="overflow-y-auto overflow-x-hidden"
        max-height="75vh"
        >
            <message
            v-for="(message, index) of getMessages"
            v-bind:message="message"
            v-bind:users="localUsers"
            v-bind:key="index"
            ></message>

            
        </v-card>
        <v-card outlined>
                <!-- Small avatars that show who the message has been read by -->
                <v-slide-x-reverse-transition>
                    <v-row class="mr-2">
                        <v-spacer></v-spacer>
                        <!-- List of avatars that will only show conditionally if they have read the message -->
                            <v-avatar
                            v-for="(user, index) of getReadUsers"
                            color="indigo"
                            size="24"
                            class="mr-1"
                            v-bind:key="index"
                            >
                                <img v-if="hasImage(user)"
                                :src="getUserImage(user)"
                                >
                                <span v-else>{{getUserName(user).substring(0,1)}}</span>
                            </v-avatar>
                    </v-row>
                </v-slide-x-reverse-transition>
        </v-card>

        <v-divider></v-divider>

        <v-slide-y-reverse-transition>
            <v-card flat>
                <v-row>
                    <v-col cols="12" md="11" sm="10" xs="9" class="flex-shrink-1">
                        <v-textarea
                            class="pl-3 pr-3"
                            v-model="newMessage.content"
                            label="Enter Message Here"
                            :counter="messageRules.max"
                            rows="2"
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="1" sm="2" xs="3" class="flex-grow-1">
                        <v-dialog
                            v-model="emojiDialog"
                            max-width="325px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi-emoticon</v-icon>
                            </v-btn>
                            </template>
                            <VEmojiPicker @select="selectEmoji" />
                        </v-dialog>                        
                        <v-btn
                        icon
                        :disabled="(newMessage.content.length === 0 || newMessage.content.length > messageRules.max)"
                        color="primary"
                        @click="sendMessage()"
                        >
                            <v-icon>mdi-send</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-slide-y-reverse-transition>
    </v-card>    
</template>

<script>
import fb from '@/fb.js'
import ChatDataService from './../../services/chatDataService.js';
import UserDataService from './../../services/userDataService.js';
import Message from './Message.vue';
import VEmojiPicker from 'v-emoji-picker';
import moment from 'moment'
import Toast from './../../plugins/customToast.js';

export default {
    data () {
        return {
            localUsers: [],
            usersLoading: false,
            localChat: {},
            chatDataService: {},
            unsubscribe: null,
            newMessage: {
                content: "",
                date: "",
                id: ""
            },
            messageRules: {
                max: 250
            },
            emojiDialog: false
        }
    },
    components: {
        Message,
        VEmojiPicker
    },
    props: {
        chatId: String,
        userIds: Array,
        userId: String
    },
    computed: {
        getMessages(){
            //This computed should refresh every time our local 'messages variable refreshes'
            return this.localChat.messages;
        },
        getReadUsers(){
            return this.localUsers.filter(user => this.hasReadMessage(user));
        }
    },
    mounted(){
        this.chatDataService = new ChatDataService();

        //Load the chat and the users via a listener
        this.loadChat();
    },
    methods: {
        loadChat(){
            var that = this;

            //Load the chat with a listener here
            this.unsubscribe = fb.db.collection('chats').doc(this.chatId)
            .onSnapshot(function(doc) {
                that.localChat = doc.data();
                //Load Users from here if they aren't already populated
                that.loadUsers();

                //Count the chat as 'Read'
                // Need to cancel this listener
                that.chatDataService.readChat(that.userId, that.chatId)
            });            
        },
        loadUsers(){
            //Load the full user data so that it can be propped into the message components for correct message avatars etc.
            const service = new UserDataService();

            //Get the list of ids to load
            var idList = JSON.parse(JSON.stringify(this.userIds));
            if (this.localChat.type === "Private"){
                idList.shift();
            }
            //We'd load all the user info in here using the userDataService
            service.searchFirebaseByUserIdList(idList)
            .then((returnedUsers) => {
                //If this is successfully resolved, we then have to put the users into our local array of 'full' users
                this.localUsers = returnedUsers;
                this.usersLoading = true;
            }).catch(function(error){
                Toast.fire({  icon: 'error',  title: `Unable to load users: ${error}`});
            });

        },
        closeDialog(){
            //Emit so that the parent call knows that the dialog has closed
            this.$emit("dialogClosed");

            //Call the unsubscribe so we no longer have an active listener
            this.unsubscribe();
        },
        onScroll(){
            //Do something as the user scrolls down the chat?
        },
        sendMessage(){
            //Construct the message object
            this.newMessage = {
                uid: this.userId,
                content: this.newMessage.content,
                date: moment().format('MM-DD-YYYY hh:mm A')
            }

            console.log("Sending message: " + this.newMessage.content); //eslint-disable-line

            this.chatDataService.sendNewMessage(this.newMessage, this.chatId)
            .then(() => {
                Toast.fire({  icon: 'success',  title: `Message sent!`});
            })
            .catch((error) => {
                Toast.fire({  icon: 'error',  title: `Error sending message: ${error}!`});
            })
            
            //Reset the message
            this.newMessage = {
                content: "",
                date: "",
                id: ""
            }
        },
        selectEmoji(emoji) {
            this.newMessage.content = this.newMessage.content + emoji.data;
            console.log(emoji) //eslint-disable-line
        },
        hasReadMessage(user){
            if (this.localChat.read.includes(user.uid)){
                return true;
            }
            return false;
        },
        hasImage(user){
            // Eventually we will add a check in here to see if the url is valid
            if (user.photo === "") {
                //If this user doesn't exist 
                return false
            }
            return true;
        },
        getUserImage(user){
            return user.photo;
        },
        getUserName(user){
            return user.displayname;
        },
    }
}
</script>